module.exports = __webpack_public_path__ + "img/pic1.49c78835.png";